import { stats } from "@/mocks/positiveNews";

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[560px] w-full flex-col justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=bright%20hopeful%20wide%20scene%20of%20a%20friendly%20neighborhood%20at%20sunrise%20with%20warm%20golden%20sunlight%20spilling%20over%20low%20rooftops%2C%20community%20volunteers%20and%20residents%20gathering%20on%20a%20sunny%20plaza%2C%20soft%20haze%20and%20long%20shadows%2C%20warm%20cream%20and%20coral%20tone%20palette%2C%20cinematic%20editorial%20documentary%20photography%2C%20uplifting%20peaceful%20mood%2C%20high%20detail&width=1920&height=1280&seq=hero-sunrise-01&orientation=landscape"
        alt="清晨阳光下邻里互助的暖心社区场景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-900/50 to-background-950/70" />

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 py-16 text-center md:py-24 md:px-6">
        <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs tracking-widest text-accent-100 md:text-sm">
          <i className="ri-sparkling-2-fill text-accent-300" />
          红黑料 · 正面爆料频道
        </p>
        <h1 className="font-heading mx-auto max-w-4xl text-3xl leading-snug font-bold text-background-50 md:text-5xl md:leading-snug">
          只讲好人好事，<br className="md:hidden" />
          发现<span className="text-accent-300">值得点赞</span>的人和事
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          看腻了负面，来这里换换口味。每天精选红料合集与高光时刻，让每一次善意的选择都被看见、被记住、被传递。
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#hot"
            className="w-full whitespace-nowrap rounded-full bg-accent-500 px-7 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-600 sm:w-auto cursor-pointer"
          >
            <i className="ri-fire-line mr-1.5 align-[-1px]" />
            看看今日红料
          </a>
          <a
            href="#contact"
            className="w-full whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/20 sm:w-auto cursor-pointer"
          >
            <i className="ri-heart-add-line mr-1.5 align-[-1px]" />
            分享身边温暖
          </a>
        </div>
      </div>

      {/* 数据亮点 */}
      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 pb-10 md:px-6">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-background-50/20 bg-background-50/10 backdrop-blur md:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="flex flex-col items-center bg-background-950/20 px-4 py-5">
              <span className="font-heading text-2xl font-bold text-accent-300 md:text-3xl">{s.value}</span>
              <span className="mt-1 text-xs text-background-100">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}